import checkIsTicketTypeSoldOut from './checkIsTicketTypeSoldOut';
import handleDateTimeBasedScheduled from './ticketScheduledConditions/handleDateTimeBasedScheduled';
import handleAfterTicketSaleEndsScheduled from './ticketScheduledConditions/handleAfterTicketSaleEndsScheduled';
import handleAfterTicketEndsOrSoldOutScheduled from './ticketScheduledConditions/handleAfterTicketEndsOrSoldOutScheduled';
import handleAfterTicketSoldOutScheduled from './ticketScheduledConditions/handleAfterTicketSoldOutScheduled';
import handleUntilEventStartsScheduled from './ticketScheduledConditions/handleUntilEventStartsScheduled';
import handleAlwaysAvailableScheduled from './ticketScheduledConditions/handleAlwaysAvailableScheduled';

/**
 * Checks if a ticket type is scheduled to go on sale in the future
 * @param {Object} ticketType - The ticket type to check
 * @param {Array} allTicketTypes - All ticket types for reference lookups
 * @returns {Object} - { isScheduled: boolean, hasInvalidReference: boolean }
 */
export default function checkIsTicketTypeScheduled({ ticketType, allTicketTypes = [] }) {
  if (
    !ticketType ||
    ticketType.availabilityStatus !== 'available' ||
    ticketType.status !== 'enabled'
  ) {
    return { isScheduled: false, hasInvalidReference: false };
  }

  const availabilityBehavior = ticketType.availabilityBehavior || 'always_available';
  const now = new Date();
  const entityKey = 'triggerTicketType';

  switch (availabilityBehavior) {
    case 'until_event_starts': {
      return handleUntilEventStartsScheduled();
    }
    case 'date_time_based': {
      return handleDateTimeBasedScheduled({ entity: ticketType, now });
    }

    case 'after_ticket_sale_ends': {
      return handleAfterTicketSaleEndsScheduled({
        entity: ticketType,
        entityKey,
        allEntities: allTicketTypes,
        now,
      });
    }

    case 'after_ticket_ends_or_sold_out': {
      return handleAfterTicketEndsOrSoldOutScheduled({
        entity: ticketType,
        entityKey,
        allEntities: allTicketTypes,
        checkSoldOut: checkIsTicketTypeSoldOut,
        now,
      });
    }

    case 'after_ticket_sold_out': {
      return handleAfterTicketSoldOutScheduled({
        entity: ticketType,
        entityKey,
        allEntities: allTicketTypes,
        now,
        checkSoldOut: checkIsTicketTypeSoldOut,
      });
    }
    case 'always_available':
    default:
      return handleAlwaysAvailableScheduled();
  }
}
